// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataspace-content-loading {
  --content-loader-navy: #10284a;
  --content-loader-blue: #1759ad;
  --content-loader-ink: #14253d;
  --content-loader-muted: #64748b;
  --content-loader-track: #dce4ef;
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 230px);
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0;
  padding: 3rem 1.25rem;
  overflow: hidden;
  color: var(--content-loader-ink);
  font-family: Manrope, Inter, ui-sans-serif, system-ui, -apple-system,
    BlinkMacSystemFont, "Segoe UI", sans-serif;
  background:
    radial-gradient(circle at 50% 38%, rgba(23, 89, 173, 0.075), transparent 18rem),
    #fff;
  text-align: center;
}

.dataspace-content-loading--compact {
  height: auto;
  min-height: 12rem;
  padding: 1.5rem 1.25rem;
  border-radius: 1rem;
}

.dataspace-content-loading--overlay {
  position: absolute;
  z-index: 3;
  inset: 0;
  width: auto;
  height: auto;
  min-height: 0;
  border-radius: inherit;
  pointer-events: none;
}

.dataspace-content-loading__mark {
  width: 5rem;
  height: 5rem;
  display: grid;
  place-items: center;
  color: var(--content-loader-blue);
  border: 1px solid #cbdcf2;
  border-radius: 1.5rem;
  background: #eff6ff;
  box-shadow: 0 14px 30px rgba(15, 40, 74, 0.1);
  transform: rotate(-5deg);
}

.dataspace-content-loading__mark svg {
  width: 2.35rem;
  height: 2.35rem;
}

.dataspace-content-loading__title {
  margin: 1.25rem 0 0.55rem;
  color: var(--content-loader-navy);
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  font-weight: 700;
  letter-spacing: -0.035em;
}

.dataspace-content-loading__message {
  max-width: 34rem;
  margin: 0;
  color: var(--content-loader-muted);
  font-weight: 650;
  line-height: 1.5;
}

.dataspace-content-loading__rail {
  width: min(18rem, 70vw);
  height: 0.25rem;
  overflow: hidden;
  margin-top: 1.5rem;
  border-radius: 999px;
  background: var(--content-loader-track);
}

.dataspace-content-loading__rail > span {
  width: 42%;
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--content-loader-blue), #4f8dd7);
  animation: dataspace-content-loading 1.25s ease-in-out infinite alternate;
}

.dataspace-content-loading--compact .dataspace-content-loading__mark {
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 1rem;
}

.dataspace-content-loading--compact .dataspace-content-loading__mark svg {
  width: 1.5rem;
  height: 1.5rem;
}

.dataspace-content-loading--compact .dataspace-content-loading__title {
  margin: 0.9rem 0 0.4rem;
  font-size: 1.05rem;
  letter-spacing: -0.02em;
}

.dataspace-content-loading--compact .dataspace-content-loading__rail {
  width: min(14rem, 70vw);
  margin-top: 1rem;
}

@keyframes dataspace-content-loading {
  from { transform: translateX(-105%); }
  to { transform: translateX(243%); }
}

@media (prefers-reduced-motion: reduce) {
  .dataspace-content-loading__rail > span {
    animation: none;
    margin: 0 auto;
    opacity: 0.62;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContentLoadingState.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,2DAA2D;EAC3D,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC;8CAC4C;EAC5C;;QAEM;EACN,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;EAC7C,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,qCAAqC;EACrC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,uEAAuE;EACvE,yEAAyE;AAC3E;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,2BAA2B,EAAE;AACpC;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".dataspace-content-loading {\n  --content-loader-navy: #10284a;\n  --content-loader-blue: #1759ad;\n  --content-loader-ink: #14253d;\n  --content-loader-muted: #64748b;\n  --content-loader-track: #dce4ef;\n  width: 100%;\n  min-width: 0;\n  height: 100%;\n  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 230px);\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0;\n  padding: 3rem 1.25rem;\n  overflow: hidden;\n  color: var(--content-loader-ink);\n  font-family: Manrope, Inter, ui-sans-serif, system-ui, -apple-system,\n    BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  background:\n    radial-gradient(circle at 50% 38%, rgba(23, 89, 173, 0.075), transparent 18rem),\n    #fff;\n  text-align: center;\n}\n\n.dataspace-content-loading--compact {\n  height: auto;\n  min-height: 12rem;\n  padding: 1.5rem 1.25rem;\n  border-radius: 1rem;\n}\n\n.dataspace-content-loading--overlay {\n  position: absolute;\n  z-index: 3;\n  inset: 0;\n  width: auto;\n  height: auto;\n  min-height: 0;\n  border-radius: inherit;\n  pointer-events: none;\n}\n\n.dataspace-content-loading__mark {\n  width: 5rem;\n  height: 5rem;\n  display: grid;\n  place-items: center;\n  color: var(--content-loader-blue);\n  border: 1px solid #cbdcf2;\n  border-radius: 1.5rem;\n  background: #eff6ff;\n  box-shadow: 0 14px 30px rgba(15, 40, 74, 0.1);\n  transform: rotate(-5deg);\n}\n\n.dataspace-content-loading__mark svg {\n  width: 2.35rem;\n  height: 2.35rem;\n}\n\n.dataspace-content-loading__title {\n  margin: 1.25rem 0 0.55rem;\n  color: var(--content-loader-navy);\n  font-size: clamp(1.8rem, 4vw, 2.8rem);\n  font-weight: 700;\n  letter-spacing: -0.035em;\n}\n\n.dataspace-content-loading__message {\n  max-width: 34rem;\n  margin: 0;\n  color: var(--content-loader-muted);\n  font-weight: 650;\n  line-height: 1.5;\n}\n\n.dataspace-content-loading__rail {\n  width: min(18rem, 70vw);\n  height: 0.25rem;\n  overflow: hidden;\n  margin-top: 1.5rem;\n  border-radius: 999px;\n  background: var(--content-loader-track);\n}\n\n.dataspace-content-loading__rail > span {\n  width: 42%;\n  height: 100%;\n  display: block;\n  border-radius: inherit;\n  background: linear-gradient(90deg, var(--content-loader-blue), #4f8dd7);\n  animation: dataspace-content-loading 1.25s ease-in-out infinite alternate;\n}\n\n.dataspace-content-loading--compact .dataspace-content-loading__mark {\n  width: 3.25rem;\n  height: 3.25rem;\n  border-radius: 1rem;\n}\n\n.dataspace-content-loading--compact .dataspace-content-loading__mark svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.dataspace-content-loading--compact .dataspace-content-loading__title {\n  margin: 0.9rem 0 0.4rem;\n  font-size: 1.05rem;\n  letter-spacing: -0.02em;\n}\n\n.dataspace-content-loading--compact .dataspace-content-loading__rail {\n  width: min(14rem, 70vw);\n  margin-top: 1rem;\n}\n\n@keyframes dataspace-content-loading {\n  from { transform: translateX(-105%); }\n  to { transform: translateX(243%); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .dataspace-content-loading__rail > span {\n    animation: none;\n    margin: 0 auto;\n    opacity: 0.62;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
